import { useState, useEffect } from 'react';
import { Tabs, Spin, Card } from 'antd';

interface EmailTemplatePreviewProps {
  templateId: string;
}

export default function EmailTemplatePreview({ templateId }: EmailTemplatePreviewProps) {
  const [preview, setPreview] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPreview();
  }, [templateId]);

  const fetchPreview = async () => {
    try {
      const sampleData = {
        name: 'John Doe',
        email: 'john@example.com',
        event: 'MaximoWorld 2025',
        topic: 'Mobile Solutions',
        rating: '5/5 - Excellent',
        company: 'ACME Corporation',
        date: new Date().toLocaleDateString(),
      };

      const res = await fetch(`/api/v1/feedback/email-templates/${templateId}/preview`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(sampleData),
      });

      const data = await res.json();
      setPreview(data);
    } catch (error) {
      console.error('Error fetching preview:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: 40 }}>
        <Spin />
      </div>
    );
  }

  if (!preview) return null;

  return (
    <div>
      <Card size="small" style={{ marginBottom: 16 }}>
        <strong>Subject:</strong> {preview.subject}
      </Card>

      <Tabs
        items={[
          {
            key: 'html',
            label: 'HTML Preview',
            children: (
              <div
                style={{
                  border: '1px solid #d9d9d9',
                  borderRadius: 4,
                  padding: 20,
                  minHeight: 400,
                  backgroundColor: '#fff',
                }}
                dangerouslySetInnerHTML={{ __html: preview.html }}
              />
            ),
          },
          {
            key: 'text',
            label: 'Plain Text',
            children: (
              <pre
                style={{
                  border: '1px solid #d9d9d9',
                  borderRadius: 4,
                  padding: 20,
                  minHeight: 400,
                  backgroundColor: '#f5f5f5',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {preview.text}
              </pre>
            ),
          },
        ]}
      />

      <Card size="small" style={{ marginTop: 16, backgroundColor: '#f0f2f5' }}>
        <div style={{ fontSize: 12 }}>
          <strong>Sample Data Used:</strong>
          <div style={{ marginTop: 8 }}>
            • Name: John Doe<br />
            • Email: john@example.com<br />
            • Event: MaximoWorld 2025<br />
            • Topic: Mobile Solutions<br />
            • Rating: 5/5 - Excellent<br />
            • Company: ACME Corporation
          </div>
        </div>
      </Card>
    </div>
  );
}
